import getConfig from "next/config";

import Alert from "@components/Alert";
import Modal from "@components/Modal";
import Loading from "@components/Loading";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
  },
} = getConfig();

const ListItem = ({ title, value }) => (
  <li className="mb-2 last:mb-0 text-[14px]">
    <span className="text-[#808080]">{title}</span>
    <span className="font-medium">{value}</span>
  </li>
);

const RCASavedInfoModal = ({ isLoading, vehicleDetails }) => (
  <Modal
    id={`${vehicleDetails.id}`}
    header={`Detalii despre ${vehicleDetails?.plateNo || "autovehicul"}`}
  >
    <Alert variant="info" showIcon>
      Daca doresti sa modifici aceste date, o poti face din contul tau{" "}
      {websiteTitle}, sectiunea Asigurari RCA.
    </Alert>

    {isLoading && <Loading height={120} />}

    {!isLoading && !vehicleDetails && (
      <div className="mt-[40px] text-center">
        Nu au fost gasite detalii pentru acest autovehicul.
      </div>
    )}

    {/* TODO add more info */}
    {!isLoading && vehicleDetails && (
      <div className="flex flex-col sm:flex-row gap-6 mt-[20px]">
        <div className="sm:w-[50%]">
          <div className="font-semibold text-[18px] mb-3">Date autovehicul</div>

          <ul className="space-y-2 text-sm">
            <ListItem
              title="Numar de inmatriculare:"
              value={vehicleDetails.plateNo}
            />

            <ListItem title="Serie sasiu:" value={vehicleDetails.vin || "-"} />

            <ListItem
              title="Marca si model:"
              value={vehicleDetails.commercialName || "-"}
            />

            <ListItem
              title="Putere motor (kw):"
              value={vehicleDetails.enginePowerKw || "-"}
            />
          </ul>
        </div>

        <div className="sm:w-[50%]">
          <div className="font-semibold text-[18px] mb-3">Date proprietar</div>

          <ul className="space-y-2 text-sm">
            <ListItem
              title="Nume:"
              value={
                vehicleDetails.vehicleOwner.lastName ||
                vehicleDetails.vehicleOwner.companyName ||
                "-"
              }
            />

            {vehicleDetails.vehicleOwner.legalType === "PF" && (
              <ListItem
                title="Prenume:"
                value={vehicleDetails.vehicleOwner.firstName || "-"}
              />
            )}

            <ListItem
              title={
                vehicleDetails.vehicleOwner.legalType === "PF" ? "CNP:" : "CIF:"
              }
              value={vehicleDetails.vehicleOwner.cif || "-"}
            />
          </ul>
        </div>
      </div>
    )}
  </Modal>
);

export default RCASavedInfoModal;
